var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-prize bg"},[(_vm.prizeList.length === 1)?_c('PrizeOne',{attrs:{"prize-list":_vm.prizeList}}):_vm._e(),(_vm.prizeList.length > 1)?_c('PrizeMore',{attrs:{"prize-list":_vm.prizeList}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }